export interface PageSearch {
  page: number
}

/** `?page=` is a positive integer or 1; anything else is silently page 1. */
export function parsePageSearch(search: Record<string, unknown>): PageSearch {
  const page = Number(search.page)
  return { page: Number.isInteger(page) && page > 0 ? page : 1 }
}
